import http from "@/utils/http"

/**
 * 抽奖信息
 * @param {object} params
 */
export function getGameInfo(params) {
    return http({
        url: "/turntable/api/turntable/info",
        data: params
    })
}
/**
 * 开始抽奖
 * @param {object} params
 */
export function startLottery(params) {
    return http({
        url: "/turntable/api/turntable/lottery",
        data: params
    })
}
/**
 * 分页查询中奖记录
 * @param {object} params
 */
export function getRecordPage(params) {
    return http({
        url: "/api/game/recordPage",
        data: params
    })
}

